import React, { useContext } from 'react';

import Dashboard from "../../components/Dashboard/Dashboard";
import Main from "../../components/Container/Container";
import Regua from '../../components/Regua/Regua';
import Footer from '../../components/Footer/Footer';
import SEO from '../../components/SEO/SEO';

import { MenuContext } from '../../context/MenuContext';
import { handleLogout } from '../../security/keycloak';

const LayoutPrivate = (props) => {
  const { open, setOpen } = useContext(MenuContext);

  const handleDrawerOpen = () => setOpen(true);
  const handleDrawerClose = () => setOpen(false);

  return (
    <>
      <SEO title={props.title ?? 'Área Restrita'} />
      <Dashboard
        open={open}
        handleDrawerOpen={handleDrawerOpen}
        handleDrawerClose={handleDrawerClose}
      />
      <Main open={open} >
        {props.children}
      </Main>
      <div className='no-print'>
        <Regua open={open} />
        <Footer open={open} />
      </div>
    </>
  )
}

export const Layout = (props) => {
  return (
    <LayoutPrivate
      handleLogout={() => handleLogout(`${process.env.REACT_APP_PUBLIC_URL}`)}
    >
      {props.children}
    </LayoutPrivate>
  )
}

export default LayoutPrivate;